module.exports = __webpack_public_path__ + "i18n/it.afe88199ccedb7250e9754f28a308acb.json";